<template>
  <Wrapper
    ref="wrapper"
    type-list="friends"
    :item-source="fetchFriends"
    :popover-position-target="popoverPositionTarget"
    :popover-items="items"
    :dummy-props="{
      headerText: $t(
        '_web_account-list_dummy_friends',
        'You have no friends at the moment'
      ),
      text: $t(
        '_web_account-list_dummy_friends_subheader',
        'Your current and future friends are waiting for you. Do not hesitate to find them'
      ),
    }"
    @hidePopover="popoverPositionTarget = null"
  >
    <ListItemAccount
      v-if="!user.isHidden"
      :key="user.login"
      slot-scope="{ user }"
      v-bind="{
        type: user.type,
        avatar: user.avatar,
        name: $filters.displayName(user),
        accountId: user.login,
        approved: user.approved,
        vanityId: user.vanityId || user.vanity_id,
      }"
      class="mb-3 py-2 pl-5 pr-5"
    >
      <div
        v-if="account._canEdit && myAccountId !== user.login"
        slot="action"
        class="d-flex align-items-center"
      >
        <FollowBtn
          v-if="myAccountId !== user.login"
          :model="createAccountModel(user)"
          follow-class=""
          class="h-mr-3"
          @toggleFollow="isFollow => toggleFollow(isFollow, user)"
        />
        <AppIcon
          name="dots"
          class="cursor-pointer px-3 py-4"
          :fill="$scss.heraMuted"
          :hover-fill="$scss.hoverColor"
          @click.stop="event => dotsClickHandler(event, user)"
        />
      </div>
    </ListItemAccount>
  </Wrapper>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { friendRequest /*report*/ } from '@/mixins/accountActions/profile';
import AppIcon from '@/components/atoms/Icon';
import ListItemAccount from '@/components/common/ListItemAccount';
import Wrapper from '../ListWrapper';
import FollowBtn from '@/components/common/FollowBtn';
import AccountModel from '@/models/Account';

export default {
  name: 'AccountFriends',
  components: {
    Wrapper,
    ListItemAccount,
    AppIcon,
    FollowBtn,
  },
  mixins: [friendRequest /*report*/],
  data() {
    return {
      items: null,
      popoverPositionTarget: null,
    };
  },
  computed: {
    ...mapState('current', ['account']),
    ...mapState('my', { myAccount: 'account', myAccountId: 'accountId' }),
  },
  methods: {
    ...mapActions(['fetchFriends']),
    toggleFollow(isFollow, user) {
      this.$set(user['social_metadata'], 'is_follow', isFollow);
      if (this.myAccount === this.account) {
        this.myAccount.updateCounters({
          following: isFollow ? +1 : -1,
        });
      }
    },
    getAccountSocial(user) {
      const social = user.social_metadata || {};

      return {
        isFollow: social.is_follow,
        isFriend: social.is_friend,
        isFriendRequested: social.is_friend_requested,
        isFriendRequestedBy: social.is_friend_requested_by,
      };
    },
    removeFromFriends(user) {
      this.friendRequestProfileAction({
        socials: this.getAccountSocial(user),
        accountId: user.login,
        accountType: user.type,
      }).then(({ addedToFriend, removedToFriend }) => {
        this.$set(user, 'isHidden', true);
        this.popoverPositionTarget = null;
        this.$refs.wrapper.pingScroll();

        if (addedToFriend || removedToFriend) {
          this.myAccount.updateCounters({
            friends: addedToFriend ? +1 : removedToFriend ? -1 : 0,
          });
        }
      });
    },
    dotsClickHandler(event, user) {
      this.items = [
        {
          label: this.friendRequestProfileText({
            socials: this.getAccountSocial(user),
          }),
          action: this.removeFromFriends.bind(this, user),
          loading: this.waitingFriendRequest,
        },
        /*{
          label: this.reportProfileText(),
          action: () => this.reportProfileAction(),
          loading: this.waitingReportRequest,
        },*/
      ];
      this.popoverPositionTarget = event.target;
    },
    createAccountModel(user) {
      return new AccountModel(user.type, user.login).update(user);
    },
  },
};
</script>
